import Compressor from 'compressorjs'

export const ImageProcess = {
  /**
   * 取得壓縮過的圖片
   * 1. 需安裝套件 compressorjs (https://www.npmjs.com/package/compressorjs)
   * @param {File | Blob} originalFile 原始檔案
   * @param {Object} passedOptions 傳入參數 (https://www.npmjs.com/package/compressorjs#options)
   * @returns {Promise<File | Blob>}
   */
  getCompressedImage: async (originalFile, passedOptions = {}) => {
    try {
      // 參數(設定預設值)
      const options = {
        quality: 0.6
      }
      // 合併傳入參數
      Object.assign(options, passedOptions)
      // 執行壓縮並取得檔案
      const compressedFile = await new Promise((resolve, reject) => {
        new Compressor(originalFile, {
          ...options,
          success (result) {
            resolve(result) // 壓縮成功時回傳結果
          },
          error (err) {
            reject(err)
          }
        })
      })
      return compressedFile
    } catch (error) {
      console.log('壓縮失敗', error)
      return originalFile // 回傳原始檔案
    }
  },
  /**
   * 取得圖片大小
   * 1. 單位是MB(保留小數點後兩位)
   * 2. 如果傳入參數不是 File 或 Blob，則回傳 -1
   * @param {File | Blob} image 圖片
   * @returns {number}
   */
  getImageSize: (image) => {
    if (!(image instanceof Blob)) {
      // throw new Error("The input must be a File or Blob object.");
      return -1
    }
    const sizeInMB = image.size / (1024 * 1024) // 將位元組轉換為 MB
    return parseFloat(sizeInMB.toFixed(2)) // 保留小數點後兩位
  }
}
